import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import type { rootReducer } from "@reducers/index";
import type { IMetaState } from "@reducers/meta";
import { metaTagCreator } from "@reducers/meta";

export default function useMeta() {
  const dispatch = useDispatch();

  const clearMetaTag = useCallback(() => {
    dispatch(metaTagCreator.clearMetaTag());
  }, [dispatch]);

  const setMetaTag = useCallback(
    (meta: IMetaState) => {
      dispatch(metaTagCreator.setMetaTag(meta));
    },
    [dispatch],
  );

  return {
    meta: useSelector((state: TRootState) => state.meta),
    clearMetaTag,
    setMetaTag,
  };
}

type TRootState = ReturnType<typeof rootReducer>;
